import { defineMessages } from 'react-intl';

export default defineMessages({
  activateButton: {
    description: 'Button to activate returns',
    defaultMessage: 'Activate',
    id: 'S74H1Y',
  },
  advancedReturnsDescription: {
    description: 'Description for the advanced returns section',
    defaultMessage:
      'Customize a full-service portal on your website to easily manage customer returns and exchanges, including Return Merchandise Authorization (RMA) workflows and other advanced configurable settings.',
    id: 'LuAD0t',
  },
  advancedReturnsPortalUrlLabel: {
    description: 'Label for the advanced returns portal URL',
    defaultMessage: 'Advanced Returns Portal URL',
    id: 'xAy0x8',
  },
  advancedReturnsTitle: {
    description: 'Title for the advanced returns section',
    defaultMessage: '{marketplaceName} Returns & Exchanges',
    id: '45Ug0o',
  },
  configureReturnStore: {
    description: 'The button used to link to the SSR return store configuration page',
    defaultMessage: 'Configure return settings',
    id: '4WEZxx',
  },
  deactivateLink: {
    description: 'Link to deactivate returns',
    defaultMessage: 'Deactivate',
    id: 'hl0tUE',
  },
  deactivateReturnsToastTitle: {
    description: 'Toast title for deactivating the store',
    defaultMessage: 'Store Deactivation',
    id: 'Z71lBz',
  },
  deactivateStoreError: {
    description: 'Error message for the deactivate returns card',
    defaultMessage: 'An error occurred while deactivating the store. Please try again.',
    id: 'uMBvND',
  },
  deactivateStoreSuccess: {
    description: 'Success message for deactivating the store',
    defaultMessage: 'Returns & Exchanges have been deactivated for your store.',
    id: 'WV19zZ',
  },
  notSupportedText: {
    description: 'Text for unsupported feature',
    defaultMessage: 'Not supported',
    id: 'j+Rwyw',
  },
  notSupportedTooltipMessage: {
    description: 'Tooltip message for unsupported feature',
    defaultMessage: 'This feature is not available on your subscription plan.',
    id: 'dNWE+/',
  },
  recommendedBadge: {
    description: 'Label for the recommended badge',
    defaultMessage: 'Recommended',
    id: 'VZpdMW',
  },
});
